// Vendors
import React from 'react';
import { FormattedMessage } from 'react-intl';
// Components
import { TitleComponent } from '@openbank/ziniaweb-ui-components';
// Constants
import { LANDING_OPTIONS_MODAL_COMPONENT_TITLE_PROPS } from './constants/landing-options-modal-title.constants';
// Enumerations
import { LandingOptionsMethodsEnumeration } from 'components/landing-options/enumerations/landing-options-methods.enumeration';
// Styles
import { LandingOptionsModalTitleComponentStyled } from './landing-options-modal-title.component.styled';
// Translations
import { LANDING_OPTIONS_MODAL_TITLES } from './translations/landing-options-modal-title.translations';
// Types
import { LandingOptionsModalTitleComponentType } from './types/landing-options-modal-title.component.type';

const LandingOptionsModalTitleComponent = <T,>({
  selectedMethod,
}: LandingOptionsModalTitleComponentType<T>): React.JSX.Element => (
  <LandingOptionsModalTitleComponentStyled>
    <TitleComponent
      {...LANDING_OPTIONS_MODAL_COMPONENT_TITLE_PROPS}
      title={
        <FormattedMessage
          id={LANDING_OPTIONS_MODAL_TITLES[selectedMethod as LandingOptionsMethodsEnumeration]}
        />
      }
    />
  </LandingOptionsModalTitleComponentStyled>
);

export { LandingOptionsModalTitleComponent };
